import React from 'react';
import Card from '../../../Card';
import { CardWrapperAlt } from '../../styles';
/**
 * Wraps SliderItems either in a Card-Component including a headline or a normal div-wrapper.
 * div-wrapper has the name "CardWrapperAlt" to be stylable via the style of the SliderInnerWrapper that also styles the CardWrapper of the Card component
 */
var SliderCard = function (_a) {
    var children = _a.children, headline = _a.headline, hasCardLayout = _a.hasCardLayout;
    return hasCardLayout ? (React.createElement(Card, { headline: headline }, children)) : (React.createElement(CardWrapperAlt, { "data-testid": "cardWrapperAlt" }, children));
};
export default SliderCard;
//# sourceMappingURL=index.js.map